import { render } from "./wms-romaneios-list-nova.vue?vue&type=template&id=f6f7f34e"
import script from "./wms-romaneios-list-nova.vue?vue&type=script&lang=js"
export * from "./wms-romaneios-list-nova.vue?vue&type=script&lang=js"

import exportComponent from "/home/econopro-ubuntu/Documents/econopro/fonts/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__